var _excluded = ["onChangeFocusedDate", "getClosestDateToFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { useCalendarContext } from '../../CalendarContext';
import { Day } from '../Day';
import { jsx as _jsx } from "react/jsx-runtime";
export var MonthDaysGrid = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    onChangeFocusedDate,
    getClosestDateToFocus
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    size,
    isDisabled,
    weeks,
    isMobileDatePicker
  } = useCalendarContext();
  var styles = useMultiStyleConfig('_BaseCalendar', {
    isMobileDatePicker,
    size
  });
  return /*#__PURE__*/_jsx(Box, {
    role: "presentation",
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      role: "rowgroup",
      __css: styles['calendar'],
      ref: ref,
      "data-testid": "calendar-month-grid",
      "data-disabled": isDisabled || void 0
    }, props), {}, {
      children: weeks.map((week, weekIndex) => /*#__PURE__*/_jsx(Box, {
        role: "row",
        "aria-rowindex": weekIndex + 1,
        __css: styles['calendarRow'],
        children: week.map((day, i) => /*#__PURE__*/_jsx(Day, {
          day: day,
          onChangeFocusedDate: onChangeFocusedDate,
          getClosestDateToFocus: getClosestDateToFocus,
          "aria-colindex": i + 1
        }, day ? day.date.getTime() : "day-week-".concat(weekIndex, "-cell-").concat(i)))
      }, "week-".concat(weekIndex)))
    }))
  });
});
//# sourceMappingURL=MonthDaysGrid.js.map